import { useMemo } from "react";

import { checkFeatureFlagGate } from "@wac-web/utils/feature-flags/check-feature-flag";
import { featureFlags } from "@wac-web/utils/feature-flags/feature-flag-manifest";

import { useFastshiftSelector } from "@/state";
import type { UserAccess } from "@/state/types";

export const useUserInfo = (): UserAccess => {
    const isGeneralAccessEnabled = checkFeatureFlagGate(
        featureFlags.sxpFastshiftEnableGeneralAccess
    );

    const userAccess = useFastshiftSelector((state) => state.userAccess);
    const userDetails = useFastshiftSelector((state) => state.userDetails);

    return useMemo<UserAccess>(() => {
        if (isGeneralAccessEnabled) {
            return userAccess;
        }

        return {
            ...userDetails,
            data: userDetails.data
                ? {
                      ...userDetails.data,
                      hasMoveTicketAccess: true
                  }
                : null
        };
    }, [isGeneralAccessEnabled, userAccess, userDetails]);
};
